import type { FleetDeviceComplianceStatus } from 'src/api/endpoints/cloudEnterprise.types';
import { Tooltip } from 'src/components';

export function ComplianceStatus({
  status = 'unknown',
}: {
  status: FleetDeviceComplianceStatus | undefined | null;
}) {
  switch (status) {
    case 'compliant':
      return (
        <span>
          <div className="mr-8 inline-block size-8 rounded-full bg-feedback-green-500 align-middle" />
          Compliant
        </span>
      );
    case 'nonCompliant':
      return (
        <Tooltip
          title={
            <p className="max-w-320 leading-16">
              This device does not meet current security policies. Ensure that
              it is connected to Wi-Fi and actively in use to complete a
              check-in. If recently paired or updated, policies may take up to
              an hour to apply.
            </p>
          }
          asChild
        >
          <span className="cursor-help">
            <div className="mr-8 inline-block size-8 rounded-full bg-feedback-red-500 align-middle" />
            Non-compliant
          </span>
        </Tooltip>
      );
    case 'notApplicable':
      return (
        <Tooltip
          title={
            <p className="max-w-320 leading-16">
              Compliance status is not applicable for this device. It either
              does not support policies or has none assigned.
            </p>
          }
          asChild
        >
          <span className="cursor-help">
            <div className="mr-8 inline-block size-8 rounded-full border border-gray-300 align-middle" />
            Not applicable
          </span>
        </Tooltip>
      );
    case 'unknown':
    default:
      return (
        <Tooltip
          title={
            <p className="max-w-320 leading-16">
              The system can&apos;t currently determine the compliance status of
              this device. This may be a connection or system error. Check that
              the device is connected to Wi-Fi and running the latest software,
              or try restarting it.
            </p>
          }
          asChild
        >
          <span className="cursor-help">
            <div className="mr-8 inline-block size-8 rounded-full bg-feedback-orange-500 align-middle" />
            Unavailable
          </span>
        </Tooltip>
      );
  }
}
